import { useEffect } from "react";
import { utmKeys } from "../utils/constants";
import { removeLocalStorageItem } from "../utils/localStorage";

const useClearLocalStorage = () => {
  useEffect(() => {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!utmKeys.includes(key)) removeLocalStorageItem(key);
    }
    sessionStorage.removeItem("active");
    return () => {
      sessionStorage.setItem("active", "true");
    };
  }, []);

  return null;
};

export default useClearLocalStorage;
